module.exports = __webpack_public_path__ + "img/disaster_page.116e8570.webp";